{
  "Automatic ({language})": "Automatisch ({language})",
  "Language": "Taal",
  "Cancel": "Annuleren",
  "OK": "OK",
  "Ok": "OK",
  "Okay": "OK",
  "Yes": "Ja",
  "No": "Nee",
  "Save": "Opslaan",
  "Saved": "Opgeslagen",
  "Saving...": "Opslaan...",
  "Saving…": "Opslaan…",
  "Delete": "Verwijderen",
  "Remove": "Verwijderen",
  "Edit": "Bewerken",
  "Change": "Wijzigen",
  "Close": "Sluiten",
  "Done": "Klaar",
  "Back": "Terug",
  "Next": "Volgende",
  "Continue": "Doorgaan",
  "Skip": "Overslaan",
  "Retry": "Opnieuw proberen",
  "Try again": "Opnieuw proberen",
  "Please try again.": "Probeer het opnieuw.",
  "Please try again": "Probeer het opnieuw",
  "Something went wrong": "Er is iets misgegaan",
  "Something went wrong. Please try again.": "Er is iets misgegaan. Probeer het opnieuw.",
  "Error": "Fout",
  "Loading...": "Laden...",
  "Loading…": "Laden…",
  "Share": "Delen",
  "Copy": "Kopiëren",
  "Copy link": "Link kopiëren",
  "Copied": "Gekopieerd",
  "Copied!": "Gekopieerd!",
  "Link copied": "Link gekopieerd",
  "Open": "Openen",
  "Restore": "Herstellen",
  "Learn more": "Meer informatie",
  "More": "Meer",
  "Help": "Hulp",
  "Settings": "Instellingen",
  "Open Settings": "Instellingen openen",
  "Profile": "Profiel",
  "Email": "E-mail",
  "Password": "Wachtwoord",
  "Name": "Naam",
  "Title": "Titel",
  "Location": "Locatie",
  "Date and time": "Datum en tijd",
  "Privacy": "Privacy",
  "Embed": "Embed",
  "Branding": "Huisstijl",
  "Logo": "Logo",
  "Guestbook": "Gastenboek",
  "Fundraising": "Inzamelingsactie",
  "Pricing": "Prijzen",
  "Plans": "Pakketten",
  "EventLive Plans": "EventLive-pakketten",
  "My Events": "Mijn evenementen",
  "Event link": "Evenementlink",
  "Event title": "Evenementtitel",
  "Go Live": "Live gaan",
  "Watch Live": "Live kijken",
  "Live only": "Alleen live",
  "Start free test": "Gratis test starten",
  "Free test": "Gratis test",
  "Unlock event": "Evenement ontgrendelen",
  "Unlock": "Ontgrendelen",
  "Sell Tickets": "Tickets verkopen",
  "Video Wall": "Videomuur",
  "Manage Video": "Video beheren",
  "Upload video": "Video uploaden",
  "What's new": "Wat is er nieuw",
  "What's New": "Wat is er nieuw",
  "Camera": "Camera",
  "Required": "Verplicht",
  "Terms": "Voorwaarden",
  "Monthly": "Maandelijks",
  "Unlimited": "Onbeperkt",
  "Not found": "Niet gevonden",
  "Not signed in": "Niet ingelogd",
  "Please sign in again.": "Log opnieuw in.",
  "Too many requests. Please wait a moment and try again.": "Te veel verzoeken. Wacht even en probeer het opnieuw.",
  "Welcome to EventLive": "Welkom bij EventLive",
  "Today": "Vandaag",
  "Tomorrow": "Morgen",
  "Yesterday": "Gisteren",
  "MMM D, YYYY": "D MMM YYYY",
  "MMM D": "D MMM",
  "h:mm A": "HH:mm",
  "h:mm a": "HH:mm",
  "Test Event": "Testevenement"
}
